export interface QuickReply {
  labelAr: string
  labelEn: string
  responseAr: string
  responseEn: string
}

export const quickReplies: QuickReply[] = [
  {
    labelAr: 'ما هي خدماتكم؟',
    labelEn: 'What are your services?',
    responseAr: 'نقدم في شليل للخدمات اللوجستية:\n• نقل بري بالشاحنات\n• نقل دولي بري\n• تخليص جمركي\n• نقل مبرد ومتخصص\n• تخزين وتوزيع\n\nهل تحتاج مزيداً من التفاصيل عن خدمة معينة؟',
    responseEn: 'At Shalil Logistics we offer:\n• Truck Freight\n• Cross-Border Land Transport\n• Customs Clearance\n• Refrigerated & Specialized Transport\n• Storage & Distribution\n\nWould you like more details about a specific service?',
  },
  {
    labelAr: 'ما هي مناطق تغطيتكم؟',
    labelEn: 'What areas do you cover?',
    responseAr: 'نغطي جميع أنحاء مصر برياً:\n• القاهرة الكبرى 🚛\n• الدلتا والساحل الشمالي 🚛\n• قناة السويس والجنوب 🚛\n\nنصل إلى جميع المحافظات المصرية بخدمة موثوقة ومنتظمة.',
    responseEn: 'We cover all of Egypt by land:\n• Greater Cairo 🚛\n• Delta & North Coast 🚛\n• Suez Canal & Upper Egypt 🚛\n\nWe reach all Egyptian governorates with reliable and regular service.',
  },
  {
    labelAr: 'كيف أحجز استشارة مجانية؟',
    labelEn: 'How do I book a free consultation?',
    responseAr: 'يمكنك حجز استشارة مجانية بعدة طرق:\n📞 اتصل بنا: +201028137221\n📧 راسلنا: shelillogistics@gmail.com\n💬 أو تواصل معنا مباشرة عبر واتساب\n\nسيتواصل معك فريقنا في غضون 24 ساعة.',
    responseEn: 'You can book a free consultation in several ways:\n📞 Call us: +201028137221\n📧 Email us: shelillogistics@gmail.com\n💬 Or contact us directly via WhatsApp\n\nOur team will contact you within 24 hours.',
  },
  {
    labelAr: 'ما الفرق بين النقل الداخلي والدولي؟',
    labelEn: 'What is the difference between domestic and international transport?',
    responseAr: 'الفرق بين النقل الداخلي والدولي:\n\n🚛 النقل الداخلي:\n• نقل البضائع بين المحافظات المصرية\n• تسليم سريع خلال 24-48 ساعة\n• تتبع مستمر للشحنة\n\n🌍 النقل الدولي البري:\n• عبر المنافذ البرية إلى دول الجوار\n• متابعة جمركية متكاملة\n• وصول إلى المملكة العربية السعودية، ليبيا، والسودان',
    responseEn: 'Domestic vs International Land Transport:\n\n🚛 Domestic:\n• Moving goods between Egyptian governorates\n• Fast delivery within 24–48 hours\n• Continuous shipment tracking\n\n🌍 International Land:\n• Through border crossings to neighboring countries\n• Full customs support\n• Access to Saudi Arabia, Libya, Sudan and more',
  },
  {
    labelAr: 'هل تقدمون خدمة التتبع؟',
    labelEn: 'Do you offer tracking services?',
    responseAr: 'نعم! نقدم خدمة تتبع شاملة:\n✅ تتبع في الوقت الفعلي\n✅ تحديثات دورية عبر البريد الإلكتروني أو الرسائل\n✅ فريق متاح 24/7 للرد على استفساراتكم\n\nبمجرد تسجيل شحنتك، ستحصل على رقم التتبع الخاص بك.',
    responseEn: 'Yes! We provide comprehensive tracking:\n✅ Real-time tracking\n✅ Regular updates via email or messages\n✅ Team available 24/7 to answer your inquiries\n\nOnce your shipment is registered, you will receive your tracking number.',
  },
  {
    labelAr: 'ما هي أسعاركم؟',
    labelEn: 'What are your prices?',
    responseAr: 'أسعارنا تعتمد على عدة عوامل:\n• نوع النقل (داخلي/دولي)\n• حجم ووزن البضاعة\n• الوجهة والمسافة\n• نوع الشاحنة المطلوبة\n\nللحصول على عرض سعر دقيق ومجاني، تواصل معنا الآن:\n📞 +201028137221\n📧 shelillogistics@gmail.com',
    responseEn: 'Our prices depend on several factors:\n• Type of transport (domestic/international)\n• Volume and weight of goods\n• Destination and distance\n• Type of truck required\n\nFor an accurate and free price quote, contact us now:\n📞 +201028137221\n📧 shelillogistics@gmail.com',
  },
]
